import Rails from '../src/js/vendor/ujs';

import tabs from '../src/js/tabs';
import selectAutoRedirect from '../src/js/select-auto-redirect';
import moreLessToggle from '../src/js/more-less-toggle';
import disableOnClick from '../src/js/disable-on-click';
import validateNumberInputs from '../src/js/validate-number-inputs';
import addDatePickers from '../src/js/add-date-pickers';
import enableSubmitOnInputChange from '../src/js/enable-submit-on-input-change';
import enableClipboard from '../src/js/enable-clipboard';
import swapLessMore from '../src/js/swap-less-more';
import '../src/js/facebox-trigger';
import { initToggleActive } from '../src/js/toggle-active';
import enableTippy from '../src/js/enable-tippy';
import '../src/js/vendor/timezone';
import '../src/js/vendor/facebox';
import initCookieBanner from '../src/js/cookie-banner';

document.addEventListener('DOMContentLoaded', () => {
  Rails.start();
  initToggleActive();
  tabs();
  selectAutoRedirect();
  moreLessToggle();
  disableOnClick();
  validateNumberInputs();
  addDatePickers();
  enableSubmitOnInputChange();
  enableClipboard();
  swapLessMore();
  enableTippy();
  initCookieBanner();
});
